import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ConfigService} from '../../../core/services/config.service';
import {RequestService} from '../../../core/services/request.service';
import {AmberApi} from '../../../core/models/api-helpers';

@Injectable()
export class ExamResultsCertificatesService{

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ){}

    saveResults(results: any): Observable<any>{
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.exam.fulfillment.results.api;
        return this.requestService.post(url, results);
    }

    getLanguages(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.language.dictionary.api;
        return this.requestService.get(url).extract(AmberApi.Data);
    }

    getLearners(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.exam.learners.list.api + '/' + id;
        return this.requestService.get(url, {page:1, limit:1000000}).extract(AmberApi.Data);
    }

    issueCertificate(voucher: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.exam.fulfillment.certificates.issue.api + '/' + voucher;
        return this.requestService.post(url, {})
    }
}



// WEBPACK FOOTER //
// ./src/app/solar/common/results-certificates/exam-results-certificates.service.ts